<template>
  <div class="container">
    <router-view ref="container"></router-view>
  </div>
</template>

<script>
export default {
  name: 'container',
  props: {
    classData: Object,
  },

  watch: {
    classData() {
      console.log('今日课程')
      console.log(this.classData)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  // height: calc(100% - 20px);
  height: 100%;
}
</style>
